import type { SiteSettings } from "@akhshy/types";
import { Pill } from "../atoms/Pill.tsx";
import { ShelfFolder } from "../molecules/ShelfFolder.tsx";
import { LuggageTag } from "../molecules/LuggageTag.tsx";
import { LabdBanner } from "./LabdBanner.tsx";
import { CHANNELS, DESK_SECTIONS, LEARN_CTA } from "../../lib/profile.ts";

function IntroColumn({ settings }: { settings: SiteSettings }) {
  return (
    <div className="home-intro-text">
      <p className="eyebrow">{settings.eyebrow}</p>
      <h1 className="display">
        {settings.headline} <span className="accent">{settings.headlineAccent}</span>
      </h1>
      <p className="hero-sub">{settings.heroSub}</p>
      <p className="home-desk-note" aria-hidden="true">
        {settings.deskNote}
      </p>
      <div className="home-now">
        <span className="home-now-label">Now</span>
        {settings.nowPills.map((p) => (
          <Pill key={p.label} label={p.label} />
        ))}
      </div>
      <a className="home-cta" href={LEARN_CTA.href} target="_blank" rel="noopener">
        {LEARN_CTA.label}
      </a>
    </div>
  );
}

function Shelf() {
  return (
    <div className="home-shelf">
      <section aria-labelledby="home-folders-title">
        <div className="home-shelf-head">
          <h2 id="home-folders-title">In the drawers</h2>
          <p>the rest of the desk</p>
        </div>
        <div className="home-folders">
          {DESK_SECTIONS.map((f) => (
            <ShelfFolder key={f.to} {...f} />
          ))}
        </div>
      </section>
      <section aria-labelledby="home-tags-title">
        <div className="home-shelf-head">
          <h2 id="home-tags-title">Where to find me</h2>
          <p>tags on the bag by the door</p>
        </div>
        <div className="home-tags">
          {CHANNELS.map((t) => (
            <LuggageTag key={t.href} {...t} />
          ))}
        </div>
      </section>
    </div>
  );
}

/**
 * Home page header: who I am on the left, the shelf of sections and channels on the right,
 * and the labd band, which the grid places by width (see .home-intro in index.css).
 */
export function HomeHero({ settings }: { settings: SiteSettings }) {
  return (
    <header className="home-wrap home-intro">
      <IntroColumn settings={settings} />
      <Shelf />
      <LabdBanner />
    </header>
  );
}
